import { MainTabConfig } from '../types';

export const isMainTabHidden = (mainTabs: MainTabConfig[], key: string): boolean =>
  mainTabs.find((tab) => tab.key === key)?.hidden ?? false;

export const toggleMainTabHidden = (mainTabs: MainTabConfig[], key: string): MainTabConfig[] =>
  mainTabs.some((tab) => tab.key === key)
    ? mainTabs.map((tab) => (tab.key === key ? { ...tab, hidden: !tab.hidden } : tab))
    : [...mainTabs, { key, hidden: true }];
